export interface IUserACL {
  clinics?: string[];
  clinicId?: string;
  clinicianId?: string;
  clinicians?: string[];
  limbicPatientId?: string;
  clinicianPatientId?: string;
  limbicPatients?: string[];
  signupCode?: string;
}

export type UserType = 'ADMIN_LIMBIC' | 'ADMIN_CLINIC' | 'PATIENT' | 'CLINICIAN';

export interface IRole {
  id: string;
  name: string;
  nameDisplay: string;
  permissions: string[];
}

export interface IUser {
  id: string;
  email: string;
  nameFirst: string;
  nameLast: string;
  active: boolean;
  emailVerified: boolean;
  type: UserType;
  role: IRole;
  roleId: string;
  acl: IUserACL;
  createdAt: string;
  updatedAt: string;
}

export interface IUserToken {
  acl: IUserACL;
  userId: string;
  clinicId: string;
  clinicianId: string;
  email: string;
  exp: number;
  iat: number;
  name: string;
  userType: UserType;
  permissions?: string[];
}

export interface IUserLogin {
  user: string;
  pass: string;
}

export interface IUserLoginResponse {
  accessToken: string;
  expiresIn: number;
  tokenType: string;
  userType: string;
}

export interface IUserReset {
  token: string;
  pass: string;
}

export interface IUserActivate extends IUserReset {
  nameFirst: string;
  nameLast: string;
}

export interface IUserInvite {
  email: string;
  role: number;
  msg: string;
  clinicId?: string;
  firstName?: string;
  lastName?: string;
}
